import React, { useState, useEffect } from "react";
import { component } from "picoapp";
import ReactDOM from "react-dom";

const calculateTimeLeft = () => {
  let targetDate = +new Date("23 Mar 2022 11:00:00 UTC-10").setHours(11);
  const difference = targetDate - +new Date();
  let timeLeft = {};
  if (difference > 0) {
    timeLeft = {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / 1000 / 60) % 60),
    };
  }
  return timeLeft;
};

function Countdown({ node, ctx }) {
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
    }, 30000);

    return () => clearTimeout(timer);
  });

  const timerComponents = [];

  Object.keys(timeLeft).forEach((interval, i) => {
    if (!timeLeft[interval]) {
      return;
    }
    timerComponents.push(
      <span key={i} className="countdown__interval">
        <span>{timeLeft[interval]}</span> <span>{interval} </span>
      </span>
    );
  });
  return (
    <>
      {timerComponents.length ? (
        <div className="countdown__text-wrapper">
          <div>
            New Product Launch! Get <strong>Knife Shield</strong> in:
          </div>
          <div className="timer__components">{timerComponents}</div>
        </div>
      ) : (
        <span>
          New Product Launch! <strong>Knife Shield</strong> is available now!
        </span>
      )}
    </>
  );
}
export default component((node, ctx) => {
  const element = <Countdown node={node} ctx={ctx} />;
  ReactDOM.render(element, node);

  return function () {
    try {
      ReactDOM.unmountComponentAtNode(node);
    } catch (e) {
      console.error(e);
    }
  };
});
